/**
 * A utilty function that handles programmatic focusing from one element (`currentElement`) to another element (`nextElement`).
 * It handles .focus() as well as tabIndex changing.
 *
 * @param currentElement the current element you're focused on. If the focus is being called to an element for the first time and there is no current focused element, set this to `null`.
 * @param nextElement the next element you want to shift focus to.
 * @param tabIndices optional set of 2 numbers which define what the tabIndices will be after this focus event takes place. The first number is the new tabIndex for the currentElement and the second is the new tabIndex for the nextElement.
 */
export const focusNewElement = (
    currentElement: HTMLElement | null,
    nextElement: HTMLElement,
    tabIndices?: [number?, number?]
) => {
    //if a current element is passed in...
    if (currentElement) {
        //... set the currentElement tabIndex to either the custom tabIndex or -1
        currentElement.tabIndex = tabIndices?.[0] !== undefined ? tabIndices[0] : -1;
    }
    // set the nextElement tabIndex to either the custom tabIndex or 0
    nextElement.tabIndex = tabIndices?.[1] !== undefined ? tabIndices[1] : 0;
    nextElement.focus();
};
